import {
  Box,
  Container,
  Grid,
  Link,
  List,
  ListItem,
  ListItemText,
  styled,
  Typography,
} from "@mui/material";

import React, { useCallback, useContext, useEffect, useState } from "react";
import AppBarCustom from "../KiotOnline/AppBarCustom";
import FixBottomButton from "../KiotOnline/FixBottomButton";
import GroupButtonRetail from "./GroupButtonRetail";
import CloseIcon from "@mui/icons-material/Close";
import { firebaseAndKvaLog } from "../../services/analytics/analytic.service";
import { RetailContext } from "../../contexts/retail/retailMain.context";
import { useRouter } from "../../utils/hooks/useRouter";
import { textEllipsis } from "../../utils/mixins/css/css";
import { getNamespace } from "../../services/domain/domainSetting.service";
import { IconCheckedWelcome } from "../Static/Icons/Icon";
import imageWelcome from "../../assets/images/welcome.png";

const DomUrlWebsite = styled("div")({
  display: "flex",
  gap: "12px",
  alignItems: "start",
  padding: "16px",
  border: "1px solid #E5E7E9",
  marginTop: "32px",
  borderRadius: "12px",
  "> div:nth-of-type(2)": {
    fontSize: "14px",
    lineHeight: "20px",
    "> div:nth-of-type(2)": {
      color: "#0090DA !important",
      fontSize: "16px",
      fontWeight: "600",
      lineHeight: "24px",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      width: "450px",
    },
  },
});

const DomButton = styled("div")({
  marginTop: "40px",
  display: "flex",
  gap: "20px",
  "> div:nth-of-type(1)": {
    padding: "16px 45px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    border: "1px solid #0090DA",
    borderRadius: "4px",
    color: "#0090DA",
    fontWeight: 700,
    cursor: "pointer",
  },
  "> div:nth-of-type(2)": {
    cursor: "pointer",
    color: "white",
    fontWeight: 700,
    padding: "16px 29px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "4px",
    background: "#0090DA",
  },
});

const DomPage = styled("div")({
  display: "flex",
  borderRadius: "12px",
  "> div:nth-of-type(1)": {
    flex: 1,
  },
  "> div:nth-of-type(2)": {},
});

export default function ActiveDone() {
  const router = useRouter();

  const { branchInfo, merchantInfo } = useContext(RetailContext);
  const [link, setLink] = useState("https://www.kiotviet.vn/");
  const newOnboarding = true;

  const { changeStatus } = useContext(RetailContext);
  const handClickWebsiteLink = () => {
    firebaseAndKvaLog(router.query.platform, "kv_mk_setup_linkweb");
    window.open(link, "_blank");
  };

  const handleSettingWebsite = () => {
    firebaseAndKvaLog(router.query.platform, "kv_mk_setup_setting");
    changeStatus && changeStatus(4);
  };

  useEffect(() => {
    const namespace = getNamespace(merchantInfo, branchInfo);
    setLink(`${process.env.REACT_APP_THEME_IFRAME}/retail/${namespace}`);
  }, [branchInfo, merchantInfo]);

  const FixBottom = useCallback(() => {
    switch (router.query.platform) {
      case "kiotonline":
        return <FixBottomButton />;
      default:
        return <GroupButtonRetail />;
    }
  }, [router.query.platform]);

  const AppBar = useCallback(() => {
    switch (router.query.platform) {
      case "kiotonline":
        return (
          <AppBarCustom
            onClickClose={() => {
              console.log("close");
            }}
            iconClose={
              <CloseIcon fontSize="medium" sx={{ color: "#323741" }} />
            }
          />
        );
      default:
        return <></>;
    }
  }, [router.query.platform]);

  return (
    <Box
      sx={{
        width: "100%",
      }}
    >
      {newOnboarding ? (
        <Container
          sx={{
            height: "100vh",
            display: "flex",
            alignItems: "center",
          }}
        >
          <DomPage>
            <div>
              <Typography
                variant="h2"
                color="text.secondary"
                sx={{
                  color: "#28A745",
                  fontWeight: 700,
                  fontSize: "40px",
                  lineHeight: "48px",
                }}
              >
                Kích hoạt cửa hàng online
                <br />
                thành công
              </Typography>
              <Typography
                color="text.secondary"
                sx={{
                  color: "#323741",
                  fontSize: "16px",
                  lineHeight: "24px",
                  marginTop: "16px",
                }}
              >
                Chào mừng bạn đến với <b>Kiotviet</b>, bạn đã hoàn thành việc
                tạo cửa hàng online. Nơi giúp bạn mở rộng kênh bán hàng, tăng
                doanh số và quảng cáo cửa hàng. Chia sẻ cửa hàng để bán hàng
                ngay bây giờ.
              </Typography>
              <DomUrlWebsite>
                <div>
                  <IconCheckedWelcome />
                </div>
                <div>
                  <div>Địa chỉ website của bạn:</div>
                  <div onClick={() => handClickWebsiteLink()}>{link}</div>
                </div>
              </DomUrlWebsite>
              <DomButton>
                <div onClick={handClickWebsiteLink}>Xem website</div>
                <div onClick={handleSettingWebsite}>Thiết lập website</div>
              </DomButton>
            </div>
            <div>
              <img src={imageWelcome} width={624} />
            </div>
          </DomPage>
        </Container>
      ) : (
        <>
          <AppBar />
          <Grid
            container
            spacing={2}
            maxWidth="md"
            sx={{
              margin: "auto",
              "@media (max-width: 600px)": {
                m: 0,
                width: "100%",
                flexDirection: "column",
                padding: "0 16px 80px 16px ",
                boxShadow: "#fff 2px 14px 12px -10px inset",
                zIndex: 3,
                position: "relative",
                backgroundColor: "#fff",
              },
            }}
          >
            <Grid
              item
              sm={6}
              xs={12}
              sx={{
                "@media (max-width: 600px)": {
                  padding: "0 !important",
                },
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  p: 4,
                  "@media (max-width: 600px)": {
                    m: "0 auto",
                    p: 0,
                    width: "270px",
                  },
                }}
                mt={8}
              >
                <img
                  src={
                    process.env.REACT_APP_ADMIN_URL +
                    "/img/retail/active_success.png"
                  }
                  alt=""
                  width={442}
                  height={400}
                />
              </Box>
            </Grid>
            <Grid
              item
              sm={6}
              xs={12}
              display="flex"
              sx={{
                "@media (max-width: 600px)": {
                  padding: "0 !important",
                },
              }}
            >
              <Box
                sx={{
                  display: "flex",
                }}
              >
                <Box
                  sx={{
                    mt: 8,
                    "@media (max-width: 600px)": {
                      mt: "40px",
                    },
                  }}
                >
                  <Box sx={{}} mb={3}>
                    <Typography
                      sx={{
                        fontWeight: 600,
                        fontSize: "32px",
                        lineHeight: "32px",
                        color: "#0090DA",
                        "@media (max-width: 1225px)": {
                          fontSize: "2.6vw",
                        },
                        "@media (max-width: 600px)": {
                          fontFamily: "Inter, sans-serif",
                          color: "#111315",
                          fontSize: "24px",
                          lineHeight: "32px",
                          letterSpacing: "-0.01em",
                        },
                      }}
                    >
                      Bạn đã có website bán hàng
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{
                        color: "#5A5A5A",
                        lineHeight: "32px",
                        marginTop: "34px",
                        "@media (max-width: 600px)": {
                          display: "none",
                        },
                      }}
                    >
                      Chào mừng bạn đến với
                      <strong> Kiotviet</strong>, bạn đã hoàn thành việc tạo
                      website. Nơi giúp bạn mở rộng kênh bán, tăng doanh số và
                      phổ biến gian hàng. Thiết lập hàng hóa để bán hàng ngay
                      bây giờ.
                    </Typography>
                  </Box>
                  <Box>
                    <List
                      sx={{
                        width: "100%",
                        bgcolor: "background.paper",
                        padding: 0,
                        marginTop: "34px",
                        "@media (max-width: 600px)": {
                          marginTop: "24px",
                          borderTop: "1px solid #E5E7E9",
                        },
                      }}
                    >
                      <ListItem
                        sx={{
                          marginTop: "20px",
                          padding: 0,
                          "@media (max-width: 600px)": {
                            alignItems: "flex-start",
                          },
                        }}
                      >
                        <img
                          src={
                            process.env.REACT_APP_ADMIN_URL +
                            "/img/retail/charm_circle-tick.png"
                          }
                          alt=""
                          width={24}
                          height={24}
                        />
                        <ListItemText
                          sx={{
                            marginLeft: "26px",
                            flex: 1,
                            display: "flex",
                            "@media (max-width: 600px)": {
                              marginLeft: "18px",
                              mt: 0,
                            },
                          }}
                        >
                          <Box
                            sx={{
                              ...textEllipsis(1),
                              maxWidth: "41vw",
                              overflow: "hidden",
                              whiteSpace: "nowrap",
                              display: "inline-block",
                              verticalAlign: "middle",
                              textOverflow: "ellipsis",
                              fontSize: "16px",
                              fontWeight: "400",
                              fontFamily: "Arial,Inter,sans-serif",
                              "@media (max-width: 600px)": {
                                maxWidth: "100%",
                                fontSize: "14px",
                                fontWeight: "700",
                                display: "block",
                                fontFamily: "Inter, sans-serif",
                              },
                            }}
                          >
                            Địa chỉ website của bạn: &nbsp;
                            <Link
                              sx={{
                                color: "#0090DA",
                                fontStyle: "italic",
                                textDecoration: "revert",
                                "@media (max-width: 600px)": {
                                  ...textEllipsis(2),
                                  wordBreak: "break-all",
                                  fontStyle: "normal",
                                  fontWeight: 400,
                                  marginTop: "4px",
                                },
                              }}
                              href={link}
                              target="_blank"
                              onClick={handClickWebsiteLink}
                            >
                              {link}
                            </Link>
                          </Box>
                        </ListItemText>
                      </ListItem>
                      <ListItem
                        sx={{
                          marginTop: "20px",
                          padding: 0,
                        }}
                      >
                        <img
                          src={
                            process.env.REACT_APP_ADMIN_URL +
                            "/img/retail/charm_circle-tick.png"
                          }
                          alt=""
                          width={24}
                          height={24}
                        />
                        <ListItemText
                          sx={{
                            marginLeft: "26px",
                            "@media (max-width: 600px)": {
                              marginLeft: "18px",
                            },
                          }}
                        >
                          <Box
                            sx={{
                              fontSize: "16px",
                              fontWeight: "400",
                              fontFamily: "Arial,Inter,sans-serif",
                              "@media (max-width: 600px)": {
                                maxWidth: "100%",
                                fontSize: "14px",
                                fontWeight: "700",
                                display: "block",
                                fontFamily: "Inter, sans-serif",
                              },
                            }}
                          >
                            Tăng doanh số bán hàng với KiotViet Software
                          </Box>
                        </ListItemText>
                      </ListItem>
                    </List>
                  </Box>
                  <FixBottom />
                </Box>
              </Box>
            </Grid>
          </Grid>
        </>
      )}
    </Box>
  );
}
